import { Component, EventEmitter, Output, ViewChild } from '@angular/core';
import {
  CaseFeatureTypeEnum,
} from '../../../../../../definition/case-features/interfaces/case-feauture.interfaces';
import { CaseFeatureService } from '../../../../../../definition/case-features/case-features.service';
import { catchError, forkJoin, of } from 'rxjs';
import { CaseService } from '../../../../../services/case.services';
import { ICaseFeatureInformations } from './case-feature-informations.interface';
import { CorePopupComponent } from '../../../../../../../ui-components/core-popup/core-popup.component';
import { TranslateService } from '@ngx-translate/core';
import { AppMessageService } from '../../../../../../../shared/services/app-message/app-message.service';

@Component({
  selector: 'app-case-feature-informations',
  templateUrl: './case-feature-informations.component.html',
  styleUrl: './case-feature-informations.component.scss',
})
export class CaseFeatureInformationsComponent {
  @ViewChild('popup') formPopup: CorePopupComponent;
  @Output() save = new EventEmitter<ICaseFeatureInformations[]>();
  caseFeatures: ICaseFeatureInformations[] = [];
  caseId: number;
  loading: boolean = false;

  constructor(
    private readonly caseFeatureService: CaseFeatureService,
    private readonly caseService: CaseService,
    private readonly translateService: TranslateService,
    private readonly messageService: AppMessageService
  ) {}

  initilize(caseId: number, caseTypeId: number) {
    this.caseId = caseId;
    this.caseFeatures = [];
    this.loading = true;
    forkJoin({
      features: this.caseFeatureService
        .getAll({ isActive: true, caseTypes: [caseTypeId] })
        .pipe(catchError(() => of(null))),
      caseFeatures: this.caseService
        .getCaseFeatures(caseId)
        .pipe(catchError(() => of(null))),
    }).subscribe({
      next: ({ features, caseFeatures }) => {
        this.loading = false;
        const featureItems =
          features?.items?.sort((a, b) => {
            const aSort = a?.orderNo ?? Infinity;
            const bSort = b?.orderNo ?? Infinity;
            return aSort - bSort;
          }) ?? [];
        const savedFeatures: ICaseFeatureInformations[] =
          caseFeatures?.items ?? [];

        //artık  pasif olan ama kullanıcının cevap verdiği özellikler
        const passiveFeatures = savedFeatures.filter(
          (sf) => !featureItems.some((f) => f.id === sf.feature.id)
        );

        for (const f of featureItems) {
          const hasBefore = savedFeatures.find((sf) => f.id === sf.feature.id);
          this.caseFeatures.push({
            id: hasBefore?.id ?? undefined,
            feature: f,
            answer: hasBefore?.answer ?? '',
            isActive: true,
          });
        }

        for (const f of passiveFeatures) {
          this.caseFeatures.push({
            id: f.id,
            feature: f.feature,
            answer: f?.answer ?? '',
            isActive: false,
          });
        }

        this.formPopup.openDialog();
      },
      error: () => {
        this.loading = false;
      },
    });
  }

  sendSubmit() {
    const caseFeatures: { id?: number; featureId: number; answer: string }[] =
      this.caseFeatures.map((e) => {
        let answer = '';

        if (e?.answer) {
          if (e.feature.type === CaseFeatureTypeEnum.Date) {
            answer = e.answer.toLocaleDateString();
          } else {
            answer = e.answer;
          }
        }

        return {
          id: e?.id,
          featureId: e?.feature?.id ?? 0, 
          answer,
        };
      });

    this.caseService.setCaseFeatures(this.caseId, caseFeatures).subscribe({
      next: (res) => {
        if (res.success) {
          this.formPopup.closeDialog();
          this.save.emit(res.items);
          this.messageService.successToast(
            this.translateService.instant('case.case-features.save-success'),
            ''
          );
        }
      },
    });
  }
}
